import CustomAddRemoveItemsModal from '../../../../../components/AddRemoveItemsModal/CustomAddRemoveItemsModal';
import {TABLES} from "../../../../../Apis/Tables";
import ManageRoleApp from "../Functionality/ManageRoleApp";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ManageRoleModal = ({show, onHide, selectedId, setModified, modified }) => {
    const { handleDelete, handleAdd, selectedEmployee } = ManageRoleApp({
        onHide,
        selectedId,
        setModified,
        modified
    });
    return (
        <CustomAddRemoveItemsModal
            show={show}
            onHide={onHide}
            selected={selectedEmployee}
            handleDelete={handleDelete}
            handleAdd={handleAdd}
            option={TABLES.USER_NOT_ASSIGNED_TO_ROLE}
            modelId={selectedId}
            listTransform={userListToLabelEmailPhoneValue}
        />
    );
};

export default ManageRoleModal;
